<template>
  <t-form label-width="90px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="形变值">
      <t-input-number v-model="attribute.columnNum" size="small" :min="1" :max="50" :decimal-places="0"/>
    </t-form-item>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="文本">
        <t-input v-model="attribute.title.text" size="small" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="大小">
        <t-input-number v-model="attribute.title.textStyle.fontSize" size="small" :min="2" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.textStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="位置(X)">
        <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="位置(Y)">
        <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="x轴" :expand="false">
      <t-form-item label="显示">
        <t-switch v-model="attribute.xAxis.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="指示文字">
        <t-input v-model="attribute.xAxis.name" size="small" :maxcharacter="40"/>
      </t-form-item>
      <t-form-item label="轴线显示">
        <t-switch v-model="attribute.xAxis.axisLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="轴线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLine.lineStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="刻度线">
        <t-switch v-model="attribute.xAxis.axisTick.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="网格线">
        <t-switch v-model="attribute.xAxis.splitLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLabel.color" size="small"/>
      </t-form-item>
      <t-form-item label="字号">
        <t-input-number v-model="attribute.xAxis.axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="字体倾斜">
        <t-input-number v-model="attribute.xAxis.axisLabel.rotate" :min="-180" :max="180" size="small" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="y轴" :expand="false">
      <t-form-item label="显示">
        <t-switch v-model="attribute.yAxis.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="指示文字">
        <t-input v-model="attribute.yAxis.name" size="small" :maxcharacter="40"/>
      </t-form-item>
      <t-form-item label="轴线显示">
        <t-switch v-model="attribute.yAxis.axisLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="轴颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLine.lineStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="网格线">
        <t-switch v-model="attribute.yAxis.splitLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="网格线颜色" v-if="attribute.yAxis.splitLine.lineStyle">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.yAxis.splitLine.lineStyle.color[0]"/>
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.yAxis.splitLine.lineStyle.color[1]"/>
      </t-form-item>
      <t-form-item label="刻度线">
        <t-switch v-model="attribute.yAxis.axisTick.show"  :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLabel.color" size="small"/>
      </t-form-item>
      <t-form-item label="字号">
        <t-input-number v-model="attribute.yAxis.axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="文本格式">
        <t-input v-model="attribute.yAxis.axisLabel.formatter" size="small" :maxcharacter="52"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="指示文本" :expand="false">
      <t-form-item label="宽度">
        <t-input v-model="attribute.label.width" size="small" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="高度">
        <t-input v-model="attribute.label.height" size="small" :maxcharacter="52"/>
      </t-form-item>
    </e-collapse>
    <t-form-item label="配色">
      <e-color-group v-model="attribute.colors" :max="120" :gradient="true"/>
    </t-form-item>
    <t-form-item label="X轴拖动" v-if="attribute.dataZoom">
      <t-switch v-model="attribute.dataZoom.show"/> 
    </t-form-item>
    <t-form-item label="X轴拖动高度" v-if="attribute.dataZoom && attribute.dataZoom.show">
      <t-input-number v-model="attribute.dataZoom.height" :min="0" :max="50" size="small" :decimal-places="0"/>
    </t-form-item>
  </t-form>
</template>

<script>
import EChartPosition from "@/components/designer/e-chart-position";
import EColorGroup from "@/components/designer/e-color-group";
import CptData from '@/components/element/options/comp/cpt-data';
export default {
  name: "cpt-chart-rect-stack-option",
  components: {EColorGroup, EChartPosition,CptData},
  props: {
    attribute: Object,
    cptDataForm:Object,
  },
}
</script>

<style scoped>

</style>
